<template>
  <div
    class="w-100 d-flex align-items-center position-fixed index page-header header-min-height"
    :class="[{ 'flex-row-reverse': closeButton, 'shadow-sm rounded': scroll }, getBackground]"
  >
    <div class="d-flex" v-if="removeBackButton !== true">
      <b-button
        variant="secondary rounded-0 p-0 header-min-height header-min-width"
        @click="$emit('back')"
      >
        <b-icon icon="arrow-left-short" font-scale="2.2" />
      </b-button>
    </div>
    <div class="d-flex" v-else-if="closeButton">
      <b-button
        variant="secondary rounded-0 p-0 header-min-height header-min-width"
        @click="$emit('back')"
      >
        <b-icon icon="x" font-scale="2.2" />
      </b-button>
    </div>
    <menu-logos v-else />

    <b-img :src="pageIcon" class="ml-2" v-if="pageIcon" />

    <p class="h6 text-primary mb-0 ml-2 pl-1 pr-3 truncate" v-if="pageTitle">{{ pageTitle }}</p>
  </div>
</template>

<script>
import MenuLogos from "../molecules/MenuLogos";

export default {
  name: "PageHeader",
  components: { MenuLogos },
  props: {
    pageTitle: String,
    pageIcon: String,
    removeBackButton: Boolean,
    closeButton: Boolean,
    background: String,
  },
  data() {
    return {
      scroll: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.isScrolling);
  },
  methods: {
    isScrolling(event) {
      this.scroll = true;

      if (window.scrollY === 0) {
        this.scroll = false;
      }
    },
  },
  computed: {
    getBackground() {
      return this.background ? this.background : "bg-white";
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.isScrolling);
  },
};
</script>

<style scoped lang="scss">
.page-header {
  background-color: $color-white;
  top: 0;
  left: 0;
}

.index {
  z-index: 999;
}
</style>
